import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveFilesCommand extends BaseCommand {
  CommandName = "RemoveFiles";
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
